import React from 'react';
import { Row, Col, Form, Checkbox } from 'antd';
import { CheckboxGroup } from 'common/components/input';
import { DAY_LIST, WEEK_DAY, MONTH_LIST, ORDER_LIST } from 'static/Constants';
import { SCHEDULE_FORM_LAYOUT } from 'common/components/modal-download-folder/constants';
const GRID_GUTTER = 8;
const ReportingDownloadScheduleMonthSetting = () => {
  const form = Form.useFormInstance();
  const atDays = Form.useWatch('onDays', form);
  const specificScheduleOrdinalNumeral = Form.useWatch(
    'specificOrdinalNumeral',
    form
  );
  const specificScheduleDaysOfWeek = Form.useWatch('specificDaysOfWeek', form);
  const onCheckAllChange = (e) => {
    form.setFieldsValue({
      specificDaysOfWeek: e.target.checked ? WEEK_DAY : [],
    });
  };
  const isDaysDisabled = !!specificScheduleOrdinalNumeral?.length;
  const isSpecificDisabled = !!atDays?.length;
  const isCheckboxAllDisabled =
    !!specificScheduleOrdinalNumeral?.length || !!atDays?.length;
  return (
    <>
      <Form.Item
        name='onMonth'
        label='Month'
        {...SCHEDULE_FORM_LAYOUT}
        rules={[{ required: true, message: 'Month is required' }]}
      >
        <CheckboxGroup
          column={3}
          options={MONTH_LIST}
          style={{ width: '100%' }}
          renderItem={(option) => <Checkbox value={option}>{option}</Checkbox>}
        />
      </Form.Item>
      <Form.Item name='onDays' label='Days' {...SCHEDULE_FORM_LAYOUT}>
        <CheckboxGroup
          column={6}
          options={DAY_LIST}
          disabled={isDaysDisabled}
          style={{ width: '100%' }}
          renderItem={(option) => <Checkbox value={option}>{option}</Checkbox>}
        />
      </Form.Item>
      <Row>
        <Col span={14}>
          <Form.Item
            {...SCHEDULE_FORM_LAYOUT}
            name='specificOrdinalNumeral'
            label='Specific'
          >
            <CheckboxGroup
              column={1}
              options={ORDER_LIST}
              disabled={isSpecificDisabled}
              style={{ width: '100%' }}
              renderItem={(option) => (
                <Checkbox value={option}>{option}</Checkbox>
              )}
            />
          </Form.Item>
        </Col>
        <Col span={10}>
          <Checkbox
            checked={specificScheduleDaysOfWeek?.length === WEEK_DAY.length}
            indeterminate={
              specificScheduleDaysOfWeek?.length > 0 &&
              specificScheduleDaysOfWeek?.length < WEEK_DAY.length
            }
            disabled={isCheckboxAllDisabled}
            style={{ marginLeft: GRID_GUTTER, marginBottom: GRID_GUTTER }}
            onChange={onCheckAllChange}
          >
            All
          </Checkbox>
          <Form.Item name='specificDaysOfWeek'>
            <CheckboxGroup
              column={1}
              options={WEEK_DAY}
              disabled={isSpecificDisabled}
              style={{ width: '100%' }}
              renderItem={(option) => (
                <Checkbox value={option}>{option}</Checkbox>
              )}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
export default ReportingDownloadScheduleMonthSetting;
